import React from "react";
import styles from "./SiteStripe.styles";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState, useEffect } from "react";
import { Typography, Box, useMediaQuery, Button, Link } from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import CardLink from "../../../components/CardLink";
import arrow from "../../../images/arrow.svg";
import { connect } from "react-redux";
import DOMPurify from 'dompurify';

const SiteStripe = (props) => {
  const classes = styles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm")); 

  const [userMessage, setUserMessage] = useState("");
  const [displayReadMore, setDisplayReadMore] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [siteStripeWidth, setSiteStripeWidth] = useState(window.innerWidth);

  const isTextClamped = (elm) => elm.scrollHeight > elm.clientHeight;

  useEffect(() => {
    // if manually setting, go to header.jsx and comment out displaySiteStripe conditions for desktop and mobile in jsx return code 
    // setUserMessage(
    //   "Input desired message here."
    // );
    if (
      (props.siteStripe.message !== null && props.siteStripe.message !== undefined) &&
      props.siteStripe.effectiveDate !== undefined &&
      props.siteStripe.expirationDate !== undefined
    ) {
      setUserMessage(
        `${props.siteStripe.message}`
      );
    };
  }, [props.siteStripe]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setSiteStripeWidth(window.innerWidth);
  }); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const element = document.getElementById("info-message");
    if (element && !readMore && isTextClamped(element)) {
      setDisplayReadMore(true);
    }
  }, [userMessage, siteStripeWidth, readMore]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleClick = () => {
    setReadMore(!readMore);
  };

  const SafeHtmlContent = ( htmlContent ) => {
    const cleanHtml = DOMPurify.sanitize(htmlContent);
    const hyperLinkElements = document.querySelectorAll('.siteStripeLink');
    console.log(hyperLinkElements);
    hyperLinkElements.forEach(link => {
      let isHovered = false;
      let isFocused = false;

      link.setAttribute('target', '_blank');
      if (!isHovered && !isFocused) {
        link.style.color = '#6CC2E6';
        link.style.textDecoration = 'none';
        link.style.letterSpacing = '1px';
        link.style.borderBottom = '1px solid #6CC2E6';
      }
      // link.style.fontWeight = '700'
      link.addEventListener('mouseenter', () => {
        isHovered = true;
        link.style.color = '#FFFFFF';
        link.style.letterSpacing = '1px';
        link.style.border = 'none'; // Clear existing border first
        link.style.borderBottom = '1px solid #FFFFFF';
      });
      link.addEventListener('mouseleave', () => {
        isHovered = false;
        link.style.color = '#6CC2E6';
        link.style.letterSpacing = '1px';
        link.style.border = 'none'; // Clear existing border first
        link.style.borderBottom = '1px solid #6CC2E6';
      });
        link.addEventListener('focus', () => {
        isFocused = true;
        link.style.color = '#FFFFFF';
        link.style.letterSpacing = '1px';
        link.style.border = 'none'; // Clear existing border first
        link.style.border = '3px solid #FFFFFF';
      });
      link.addEventListener('blur', () => {
        isFocused = false;
        link.style.color = '#6CC2E6';
        link.style.letterSpacing = '1px';
        link.style.border = 'none'; // Clear existing border first
        link.style.borderBottom = '1px solid #6CC2E6';
      });
    });
    
    return (
      <Typography
        component="div"
        dangerouslySetInnerHTML={{
          __html: cleanHtml
        }}
      />
    );
  };

  return matches ? (
    <>
      <div id="site-stripe-container" className={classes.mainContainer}>
        <div className={classes.containerContentMobile}>
          <Box className={classes.iconContainer}>
            <InfoOutlinedIcon className={classes.infoIcon} />
          </Box>
          <Box className={classes.textContainer}>
            <Typography
              className={readMore === false ? classes.infoText : ""}
              id="info-message"
              data-testid="info-message"
            >
              {SafeHtmlContent(userMessage)}
            </Typography>

            {displayReadMore && (
              <Button
                role="button"
                className={classes.readMoreButton}
                onClick={handleClick}
              >
                {readMore ? "Read less" : "Read more"}
              </Button>
            )}
          </Box>
        </div>
      </div>
    </>
  ) : (
    <>
      <div id="site-stripe-container" className={classes.mainContainer}>
        <div className={classes.containerContent}>
          <Box className={classes.textContainer}>
            <Box className={classes.iconContainer}>
              <InfoOutlinedIcon className={classes.infoIcon} />
            </Box>
            <Typography
              className={readMore === false && classes.infoText}
              id="info-message"
              data-testid="info-message"
            >
              {SafeHtmlContent(userMessage)}
            </Typography>
            {displayReadMore && (
              <Button
                role="button"
                className={classes.readMoreButton}
                onClick={handleClick}
              >
                {readMore ? "Read less" : "Read more"}
              </Button>
            )}
          </Box>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    siteStripe: state.siteStripe,
  };
};

export default connect(mapStateToProps)(SiteStripe);
